import { SxProps, Theme } from "@mui/material";

export const textFieldStyles: SxProps<Theme> = {
  "& input:-webkit-autofill": {
    WebkitTextFillColor: "#fff",
    caretColor: "#fff",
    transition: "background-color 5000s ease-in-out 0s",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#ffffff83",
    },
    "&:hover fieldset": {
      borderColor: "#ffffffe0",
    },

    "&.Mui-focused fieldset": {
      borderColor: "#ffffffe0",
    },
  },
};
